import SectionHead from "./SectionHead";

const RESULTS = [
  {
    icon: "ri-trophy-line",
    title: "胜负归属",
    body: "重剪版基于更完整的决策过程重新呈现结果，最终归属由现场真实表现决定，官方同步公开了评审依据，争论焦点就此落地。",
    label: "尘埃落定",
  },
  {
    icon: "ri-compass-3-line",
    title: "主角去向",
    body: "当事人选择沉淀后再出发，直播里那句“比起赢，我更怕辜负相信我的伙伴”成为整个收尾阶段被引用最多的原话。",
    label: "重新出发",
  },
  {
    icon: "ri-movie-2-line",
    title: "下季彩蛋",
    body: "片尾字幕结束后出现的空房间与一句神秘台词，几乎可以确定指向新一季的全新玩法，观众已开始疯狂考古细节。",
    label: "伏笔上线",
  },
];

const VERDICT = [
  { key: "起因一句话", text: "一份提前流出的名单，把尚未开播的最终回提前推上了风口。" },
  { key: "最大的反转", text: "不是结局本身，而是加长花絮里那段从未播出的完整对话。" },
  { key: "收尾一句话", text: "当信息足够完整，多数人的分歧都只是信息差造成的误会。" },
];

export default function Finale() {
  return (
    <section id="finale" className="relative scroll-mt-20 overflow-hidden bg-background-900 py-14 md:py-24">
      <div
        className="pointer-events-none absolute inset-x-0 top-0 h-24 bg-gradient-to-b from-background-50/5 to-transparent"
        aria-hidden="true"
      />
      <div className="page-shell relative">
        <SectionHead
          kicker="大结局复盘"
          title="结局揭晓：所有悬念都落了地"
          desc="这是本期 88大结局 的完整复盘。如果你只想知道结果、谁赢、以及接下来会怎样，读这一节就够了。"
          tone="ink"
        />

        <div className="mt-10 grid grid-cols-1 gap-4 md:grid-cols-3">
          {VERDICT.map((v) => (
            <div
              key={v.key}
              className="rounded-2xl border border-background-200/10 bg-background-800/40 p-6"
            >
              <div className="font-display text-6xl leading-none text-accent-500/90" aria-hidden="true">
                “
              </div>
              <p className="-mt-4 text-lg font-black leading-snug text-background-50">{v.text}</p>
              <p className="mt-3 text-xs font-bold tracking-[0.2em] text-background-400">{v.key}</p>
            </div>
          ))}
        </div>

        <div className="mt-4 grid grid-cols-1 gap-4 lg:grid-cols-3">
          {RESULTS.map((r, idx) => (
            <article
              key={r.title}
              className={`relative overflow-hidden rounded-2xl p-6 ${
                idx === 2
                  ? "border border-accent-400/40 bg-accent-500/15"
                  : "border border-background-200/10 bg-background-50/5"
              }`}
            >
              <div className="flex items-center gap-3">
                <span
                  className={`flex h-11 w-11 items-center justify-center rounded-xl text-2xl ${
                    idx === 2 ? "bg-accent-500 text-background-50" : "bg-primary-500 text-background-50"
                  }`}
                >
                  <i className={r.icon} aria-hidden="true" />
                </span>
                <div>
                  <h3 className="text-base font-black text-background-50">{r.title}</h3>
                  <span className="text-xs font-semibold text-accent-400">{r.label}</span>
                </div>
              </div>
              <p className="mt-4 text-sm leading-relaxed text-background-200">{r.body}</p>
            </article>
          ))}
        </div>

        <div className="mt-10 flex flex-col items-start justify-between gap-5 rounded-2xl bg-background-950/40 p-6 sm:flex-row sm:items-center">
          <div className="flex flex-wrap items-center gap-2">
            <span className="text-sm font-bold text-background-50">结局关键词：</span>
            {["真相归位", "做自己", "信息差", "重剪收官", "下季伏笔"].map((k) => (
              <span
                key={k}
                className="chip border border-background-200/15 bg-background-50/10 px-3 py-1 text-xs text-background-100"
              >
                {k}
              </span>
            ))}
          </div>
          <a
            href="#topics"
            className="inline-flex shrink-0 items-center gap-2 whitespace-nowrap rounded-full bg-accent-500 px-6 py-3 text-sm font-bold text-foreground-950 transition-colors hover:bg-accent-400"
          >
            去收尾讨论区站队
            <i className="ri-arrow-right-line" aria-hidden="true" />
          </a>
        </div>
      </div>
    </section>
  );
}